(() => {
  const loader = document.getElementById('stack-loader');
  if (!loader) return;

  const showOnce = loader.dataset.showOnce === 'true';
  const key = 'stack-loader-seen';
  const minDurationMs = parseInt(loader.dataset.minMs || '5000', 10);
  const hideTransitionMs = 700;
  const startedAt = window.__stackLoaderStart || Date.now();
  let hidden = false;

  if (showOnce) {
    try {
      if (sessionStorage.getItem(key) === '1') {
        loader.remove();
        return;
      }
    } catch (e) {}
  }

  const hideLoader = () => {
    if (hidden || !loader.isConnected) return;
    hidden = true;
    loader.classList.add('is-hidden');
    if (showOnce) {
      try {
        sessionStorage.setItem(key, '1');
      } catch (e) {}
    }
    window.setTimeout(() => loader.remove(), hideTransitionMs);
  };

  window.setTimeout(hideLoader, Math.max(0, startedAt + minDurationMs - Date.now()));
})();
